<template>
    <div class="single-dochub-resource-viewer">
        <div v-if="status == 'loading'" key="loading" class="w-100 min-height-50 d-flex justify-content-center align-items-center">
            <b-spinner label="Loading resource..." />
        </div>
        <b-alert
            v-else-if="status === 'error'"
            key="error"
            variant="danger"
            show
            class="w-100 min-height-50 text-center"
        >
            Error loading this item
        </b-alert>
        <DocHubResourceDisplay
            v-else-if="status === 'loaded'"
            key="loaded"
            :resource="resource"
            :buttonSize="buttonSize"
            :fileDownloadButtonProps="fileDownloadButtonProps"
            :layoutType="layoutType"
        >
        </DocHubResourceDisplay>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import DocHubResourceDisplay from './DocHubResourceDisplay.vue';

export default {
    name: 'SingleDocHubResourceViewer',
    components: {
        DocHubResourceDisplay
    },
    mixins: [],
    props: {
        slug: {
            type: String,
            required: true,
        },
        buttonSize: {  // changes things on fieldDownloadButtonProps, and other buttons so they are consistent
            type: String,
            required: false,  // only if you want to override the default
        },
        fileDownloadButtonProps: {
            type: Object,
            default: () => {
                return {};
            },
        },
        layoutType: {  // pass in from parent, must be one of the keys in CLASSES_FOR_LAYOUTS (from layout_type in backend enum)
            type: String,
            default: 'LIST',
        },
    },
    data() {
        return {
            loadingResource: false,
            resource: null,  // this will be the resource object from the backend
        }
    },
    computed: {
        status() {  // return 'loading', 'loaded', or 'error' based on loadingResource and resource
            return this.loadingResource ? 'loading' : (this.resource ? 'loaded' : 'not-found');
        },
    },
    created() {
        
    },
    mounted() {
        this.getResource();
    },
    methods: {
        async getResource() {
            this.loadingResource = true;
            try {
                const response = await suppliosApi.dochubResource.get_by_slug(this.slug);
                if (response && response.data) {
                    this.resource = response.data;
                } else {
                    console.error('No resource data found');
                }
            } catch (error) {
                console.error('Error fetching resource:', error);
            } finally {
                this.loadingResource = false;
            }
        }
    },
}
</script>

<style lang="scss">
</style>